import React, { useState, useEffect, useRef } from 'react';
import { formatAPIData, typeFormat } from './formatter'
import { getTicket } from '../../../../store/action/ticket';
import { CommentInput, CommentSection } from './components';

const View = (props) => {
    const ref = useRef(null);
    const [ ticket, setTicket ] = useState({
        id:props.ticketId,
        comments:[]
    });

    useEffect(() => {
        setTicket({
            ...ticket,
            id:props.ticketId
        })
        
        if (props.ticketId) {
            props.onHeightChanges(ref.current.clientHeight);
            const intervalId = setInterval(() => {
                getTicketData(props.ticketId);
            }, 1000);
            getTicketData(props.ticketId);
            return () => clearInterval(intervalId);
        }
    },[props.ticketId])

    const getTicketData = async (tId) => {
        const response = await getTicket(tId);
        if (response.success) {
            setTicket(formatAPIData(response))
        } else {
            alert(response.error);
        }
    }

    if (!props.ticketId) {
        return (
            <div className="text-center p-5">
                <p>Pilih tiket yang ingin Anda tampilkan</p>
            </div>
        )
    };

    const badge = (status) => {
        return status === 'solved' ? 'badge-success' : status === 'processing' ? 'badge-warning' : 'badge-danger'
    };
    
    return (
        <div ref={ref} className="">
            <div className='p-4'>

                <div className='row'>
                    <div className='col-9'>
                        <p>Nomor Tiket ID <text className='text-info'><b>#{ticket.id.toUpperCase()}</b></text></p>
                    </div>
                    <div className='col-3'>
                        <p>Tanggal {ticket.createdAt}</p>
                    </div>
                </div>

    
                <div className='row'>
                    <div className='col-4'>
                        <p><b>Tipe Tiket</b></p>
                    </div>
                    <div className='col-8'>
                        <p>{typeFormat(ticket.type)}</p>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-4'>
                        <p><b>Judul Tiket</b></p>
                    </div>
                    <div className='col-8'>
                        <p>{ticket.title}</p>
                    </div>
                </div>
           
                <div className='row'>
                    <div className='col-4'>
                        <p><b>Detail</b></p>
                    </div>
                    <div className='col-8'>
                        <p>{ticket.description}</p>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-4'>
                        <p><b>Pelapor Tiket</b></p>
                    </div>
                    <div className='col-8'>
                        <p>{ticket.reporterContactName} {ticket.reporterContactPhone ? `(${ticket.reporterContactPhone}) Notifikasi Aktif` : null}</p>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-4'>
                        <p><b>Nomor Tiket Internal</b></p>
                    </div>
                    <div className='col-8'>
                        <p>{ticket.referenceId}</p>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-4'>
                        <p><b>List Order</b></p>
                    </div>
                    <div className='col-8'>
                        {
                            ticket.orderIds ? ticket.orderIds.map(i => (
                                <text className='border rounded px-2 py-1 mr-1'>
                                    {i}
                                </text>))
                                :
                                null
                            
                        }
                    </div>
                </div>
            </div>
            

            <CommentInput
                ticketId={props.ticketId}
                onRefreshView={() => getTicketData(props.ticketId)}
            />

            <CommentSection
                comments={ticket.comments}
            />

        </div>
    )
};

export default View